import React, { useRef, useState } from "react";
import * as S from "./ChatbotGuidanceCase.style"
import * as P from "../../../../../../utils/pipes"
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { CONSULT_MEDICAL_GUIDANCE, CONSULT_MEDICAL_GUIDANCE_IN_FLORENCE, CONSULT_MEDICAL_PROCESS_IN_FLORENCE, CONSULT_PATIENT_HISTORY_CHAT_IN_FLORENCE, GENERATE_PATIENT_GUIDE_FILE, UPDATE_PATIENT_GUIDE_FILE } from "../../../../../../graphql/mutations/Chat";
import useSize from "../../../../../../hooks/useSize";
import { useTranslation } from "react-i18next";
import useDoctorData from "../../../../../../hooks/useDoctorData";
import ZaialoadingPoints from "../../../../../zaiaComponents/zaiaLoadingPoints";
import ChatbotInput from "../../chatbotInput";
import Message from "../../message";
import ModalSelectPatient from "../../../../shared/modals/modalSelectPatient";
import Modal from "../../../../../../utils/modal";
import ZaiaSelect from "../../../../../zaiaComponents/zaiaSelect";
import { QUERY_GET_PROCESS_NAMES, QUERY_GET_PROCESS_TYPES_BY_ID } from "../../../../../../graphql/queries/Process";
import { useMemo } from "react";
import FlorenzButton from "../../../../../florenzComponents/florenzButton";
import GuidanceCaseOptions from "./components/guidanceCaseOptions";
import ChatbotGuideSelector from "./components/chatbotGuideSelector";

const bgChatbot = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/chat-background.svg`
const defaultPatientImg = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaImgDefault/default-user2.svg`
const specificGuidesMonaco = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/specific-guides-monaco.svg`;

function ChatbotGuidanceCase(
  {
    selectedProcess,
    selectedPartition,
    selectProcess,
    selectPartition,
    selectedPatient,
    selectPatient,
    setActiveModalPatient,
    isNavigationModule
  }
) {

  const element = document.getElementById("chatbot-container");
  const {t, i18n: { language }} = useTranslation("global");
  const { doctorData } = useDoctorData();
  const [activeModalGuideSelector, setActiveModalGuideSelector] = useState(false);
  const [successUpdateGuide, setSuccessUpdateGuide] = useState(null);
  const [startChat, setStartChat] = useState(false);

  const [generatePatientGuideFile, {loading: generatePatientGuideFileLoading}] = useMutation(
    GENERATE_PATIENT_GUIDE_FILE,
    {
      fetchPolicy: "network-only"
    }
  );

  const [updatePatientGuideFile, {loading: updatePatientGuideFileLoading}] = useMutation(
    UPDATE_PATIENT_GUIDE_FILE,
    {
      fetchPolicy: "network-only"
    }
  );

  const { data: processTypes } = useQuery(
    QUERY_GET_PROCESS_TYPES_BY_ID, 
    { variables: 
      { 
        processId: [selectedProcess?.id],
        technology: "openai" 
      } 
    }
  );

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    patientMessage(values.msg, 'doctor');
    sendBotMessage(values.msg, setSubmitting, resetForm);
    autoScroll();
  }; 

  const sendBotMessage = async (msg, setSubmitting, resetForm) => {    
    try {
      if(resetForm) resetForm();
      if(setSubmitting) setSubmitting(false);

      console.log("asdfasdfasd", selectedPatient);
      
      if(selectedPatient) {
        sendChatbotMessage(msg);
      } else {
        sendChatbotMessageWithoutPatient(msg);
      }
    } catch (error) {
      console.log(error);
    }
  }


  const patientMessage = (msg, type) => {
    let allMessages = messages;
    allMessages.push(
      {
        id: Date.now(),
        message: msg,
        senderName: `${doctorData?.name} ${doctorData?.lastname}`,
        type: type
      }
    )
    setMessages([...allMessages])
  }

  const autoScroll = () => {
    if(element) element.scrollTop = element.scrollHeight - element.clientHeight;
  }

  const [chatBotPatient, {loading: chatBotPatientLoading}] = useLazyQuery(
    CONSULT_PATIENT_HISTORY_CHAT_IN_FLORENCE,
    {
      fetchPolicy: "network-only"
    }
  );

  // const [chatBotGuidance, {loading: chatBotGuidanceLoading}] = useLazyQuery(
  //   CONSULT_MEDICAL_GUIDANCE_IN_FLORENCE,
  //   {
  //     fetchPolicy: "network-only"
  //   }  
  // );

  const [chatBotGuidance, {loading: chatBotGuidanceLoading}] = useMutation(
    CONSULT_MEDICAL_GUIDANCE,
    {
      fetchPolicy: "network-only"
    }  
  );

  const [chatBotProcess, {loading: chatBotProcessLoading}] = useLazyQuery(
    CONSULT_MEDICAL_PROCESS_IN_FLORENCE,
    {
      fetchPolicy: "network-only"
    }  
  );

  const sendChatbotMessageWithoutPatient = async (msg) => {
    const partitionSelected = processTypes?.process[0]?.processGuides.find((item) => item.id === selectedPartition.value); 
    
    const {
      data: {
        clinical_guide_chatbot,
      },
    } = await chatBotGuidance({
      variables: {
        query: `${partitionSelected.fileName} - ${msg}`,
      },
    });

    if (!chatBotProcessLoading ) {
      setMessages(
        [
          ...messages,
          {
            id: Date.now(),
            message: clinical_guide_chatbot.data.messages[1].content.content,
            senderName: t("globally.chatbotName"),
            type: 'bot',
          }
        ]
      )
      autoScroll()
    }
  }
  
  const sendChatbotMessage = async (msg) => {
    const {
      data: {
        consult_medical_history_in_florence,
      },
    } = await chatBotPatient({
      variables: {
        language: language.split('-')[0],
        question: `${msg} ${t("globally.sourcesCaption")}`,
        user_id: selectedPatient?.id
      },
    });

    if (!chatBotPatientLoading ) {

      const partitionSelected = processTypes?.process[0]?.processGuides.find((item) => item.partition_name === selectedPartition.value); 

      console.log("tio, diga", partitionSelected);
      

      const {
        data: {
          clinical_guide_chatbot,
        },
      } = await chatBotGuidance({
        variables: {
          query: `${partitionSelected.fileName} - ${consult_medical_history_in_florence.answer}`,
        },
      });

      console.log(clinical_guide_chatbot);

      if (!chatBotGuidanceLoading ) {
        setMessages(
          [
            ...messages,
            {
              id: Date.now(),
              message: clinical_guide_chatbot.data.messages[1].content.content,
              senderName: t("globally.chatbotName"),
              type: 'bot',
            }
          ]
        )
        autoScroll()
      }
    }
  }
  
  const [messages, setMessages] = useState([]);

  const generatePatientGuideFileHandler = async () => {
    try {
      const {
        data: {
          generate_patient_pdf_report,
        },
      } = await generatePatientGuideFile({
        variables: {
          userId: selectedPatient?.id
        },
      });
      if(generate_patient_pdf_report.pdfSaveStatus.success) {
        const {
          data: {
            upload_patient_medical_history,
          },
        } = await updatePatientGuideFile({
          variables: {
            userId: selectedPatient?.id,
            fileName: selectedPatient?.id + ".pdf",
            fileBucketName: "zaia-health-dev_user_clinical_history_pdf"
          },
        });
        
        if(upload_patient_medical_history.error_message === null) {
          setSuccessUpdateGuide(true);
        }
      }
    } catch (error) {
      console.log(error);
      setSuccessUpdateGuide(false);
    }
  } 


  return (
    <S.ChatbotGuidanceCase 
      selectedProcess={selectedProcess}
      selectedPartition={selectedPartition}
      selectedPatient={selectedPatient}
    >
      {
        activeModalGuideSelector && (
          <div className="guide-selector-pop-up">
            <ChatbotGuideSelector
              selectedProcess={selectedProcess}
              selectProcess={selectProcess}
              selectedPartition={selectedPartition}
              selectPartition={selectPartition}
              processTypes={processTypes}
              closeFunc={() => setActiveModalGuideSelector(false)}
              isNavigationModule={isNavigationModule}
            />
          </div>
        )
      }
      {
        !startChat ?
        <GuidanceCaseOptions
          selectedProcess={selectedProcess}
          selectedPartition={selectedPartition}
          selectedPatient={selectedPatient}
          setActiveModalGuideSelector={setActiveModalGuideSelector}
          setActiveModalPatient={setActiveModalPatient}
          setStartChat={setStartChat}
        />
        : <>
          <div className="chatbot-guide-selected">
            <div className="box-guide">
              <div className="box-guide__title">
                <b>{t("globally.guide")}</b> {selectedPartition?.text}
              </div>
              <button className="box-guide__button"
                onClick={() => {
                  setStartChat(false);
                }}
              >
                {t("chatbotAI.guidelines.resetMode")}
              </button>
            </div>
          </div>
          <div className="chatbot-container" id="chatbot-container">
            {
              messages.length === 0 &&
              <div className="chatbot-container__empty">
                <img src={bgChatbot} alt="" className="chatbot-container__empty-image" />
                <div className="chatbot-container__empty-msg">
                  {t("chatbotAI.patientsGuidelines.letsTalk")}
                </div>
              </div>
            }
            {messages.map((message, index) => (
              <div key={message.id}>
                { 
                  <Message
                    key={index}
                    message={message.message?.replace('0chatgpt', '')}
                    senderName={message.senderName}
                    option={message.type}
                  />
                }
              </div>
            ))}
            { 
              chatBotPatientLoading || chatBotGuidanceLoading
              ? <Message
                senderName={t("globally.chatbotName")}
              >
                <ZaialoadingPoints />
              </Message> 
              : null
            }
          </div>
          <div className="chatbot-footer">
            <ChatbotInput
              chatbotDisabled={!(selectedProcess && selectedPartition && selectedPatient)}
              disabledText={t("chatbotAI.patientsGuidelines.inputCondition")}
              handleSubmit={handleSubmit}
            />
            {
              selectedPatient && (
                <div className="patient-selected-content">
                  <div className="patient-selected" onClick={() => setActiveModalPatient(true)}>
                    <div className="patient-selected__box-image">
                      <img src={selectedPatient.picture ?? defaultPatientImg} alt="user" className="patient-selected__image" />
                    </div>
                    <div className="patient-selected__name">
                      {`${selectedPatient.name} ${selectedPatient.lastname}`}
                    </div>
                    <i className="patient-selected__icon-close zaia-icono-cerrar"></i>
                  </div>
                  <div 
                    className="patiet-selected__update-guide"
                    onClick={() => generatePatientGuideFileHandler()}
                  >
                    {t("chatbotAI.updateGuide")}
                    <i className="patient-selected__icon-update zaia-i-refresh"></i>
                  </div>
                </div> 
              )
            }
          </div>
        </>
      } 
    </S.ChatbotGuidanceCase>
  );
}

export default ChatbotGuidanceCase;
